

import { createApp } from 'vue'
import { OktaAuth } from '@okta/okta-auth-js'
import { loadFonts } from './plugins/webfontloader'
import './assets/CSS/style.css'
import 'bootstrap/dist/css/bootstrap.css'
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.js'
import OktaVue from '@okta/okta-vue'
import App from './App.vue'
import router from './router'
loadFonts()
const oktaAuth = new OktaAuth({
  clientId: process.env.0oaj06jstw8Z6GlAt4x7,
  issuer: process.env.https://paynet.okta.com,
  redirectUri: process.env.https://nrtdashboard.prod.inet.paynet.my/login/callback,
  scopes: ['openid', 'profile', 'email'],
  pkce: true
});
createApp(App)
  .use(router)
  .use(bootstrap)
  .use(OktaVue, { oktaAuth })
  .mount('#app')
